import React, { useEffect, useLayoutEffect, useState } from 'react';
import AuthService from "../services/auth.service";
import Helpers from "../services/helpers";
import { Link, useNavigate, useParams } from 'react-router-dom';
import Loader from '../components/loader';

function PlayGame() {
  const [loading, setLoading] = useState(false);
  const [isPageloading, setIsPageLoading] = useState(true);
  const [message, setMessage] = useState("");
  const params= useParams();
  const [gameUUId] = useState<any>(params.uuid);
  const [gameLink, setGameLink] = useState<any>([]);
  const navigate = useNavigate();

  useLayoutEffect(() => {
    if (isPageloading) {
      document.body.style.overflow = "hidden";
      document.body.style.height = "100%";
    }
    if (!isPageloading) {
      document.body.style.overflow = "auto";
      document.body.style.height = "auto";
    }

  }, [isPageloading]);
  
  useEffect(() => {
    getGamesList();
          
    // eslint-disable-next-line
  }, []);

  function getGamesList(){
    //console.log(gameUUId);
    AuthService.loadGames('casino', 'load_game', gameUUId)
    .then(
      (response) => {
        // console.log(response);
        if(response?.status===200){
          setGameLink(response?.data?.url);
          window.location.replace(response?.data?.url)
        }else{
          setMessage(response.message);
        }
      }
    ).catch((error) => {
      const message = error?.response?.data?.error_description;
      setMessage(message);
      if(error?.response?.data?.status===401){
          localStorage.removeItem("w_token");
          navigate('/login');
      }
    }).finally(() => {
      setIsPageLoading(false);
    });
  }

  return (
    <>
      <div className='container'>
        {isPageloading ? 
        (
          <Loader />
        ):(
          <></>
          // <iframe src={gameLink}></iframe>
          // <embed src={gameLink} width={300} height={500} />
        )}
        
      </div>
    </>
  )
}
export default PlayGame;

